var React = require('react');

function InfoIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.04199 3.20829H5.95866V4.12496H5.04199V3.20829ZM5.04199 5.04163H5.95866V7.79163H5.04199V5.04163ZM5.50033 0.916626C2.97033 0.916626 0.916992 2.96996 0.916992 5.49996C0.916992 8.02996 2.97033 10.0833 5.50033 10.0833C8.03033 10.0833 10.0837 8.02996 10.0837 5.49996C10.0837 2.96996 8.03033 0.916626 5.50033 0.916626ZM5.50033 9.16663C3.47908 9.16663 1.83366 7.52121 1.83366 5.49996C1.83366 3.47871 3.47908 1.83329 5.50033 1.83329C7.52158 1.83329 9.16699 3.47871 9.16699 5.49996C9.16699 7.52121 7.52158 9.16663 5.50033 9.16663Z","fill":"currentColor"}));
}

InfoIcon.defaultProps = {"viewBox":"0 0 11 11"};

module.exports = InfoIcon;

InfoIcon.default = InfoIcon;
